export const style = {
  card: {
    CardContent: {
      dateBlock: {
        boxMain: {
          display: 'flex',
          gap: 2,
        },
        boxInner: {
          width: '100%',
        },
        chackboxLabel: {
          display: 'flex',
          alignItems: 'center',
        },
        boxRow: {
          display: 'flex',
          marginBottom: '10px',
          alignItems: 'center',
        },
        typography: {
          variant: 'subtitle1',
          width: '100%',
          sx: {
            pb: 1,
            color: 'primary.text',
            fontWeight: '600',
          },
        },
        icon: {
          color: 'primary.main',
        },
      },
      cardContentContainer: {
        sx: {
          m: 2,
          pY: 4,
          pX: 2,
          borderRadius: 2,
          border: 1,
          borderColor: 'divider',
        },
      },
      boxRow: {
        display: 'flex',
        gap: '10px',
        marginBottom: '10px',
        alignItems: 'center',
      },
      boxTrash: {
        color: 'action',
        sx: {
          width: 25,
          mt: 2,
          pX: 2,
          '&: hover': {
            cursor: 'pointer',
          },
        },
      },
      textField: {
        field: {
          gap: 15,
          flex: 1,
          flexGrow: 1,
        },
        sx: {
          fullWidth: 'fullWidth',
          variant: 'outlined',
        },
      },
    },
  },
} as const;
